<template>
  <div class="guides-references-item">
    <div class="guides-references-item-head">
      <div :class="`guides-references-item-name${isEditMode ? ' active' : ''}`">{{currentName}}</div>
    <el-select filterable v-if="this.displayUsers" v-model="newUsers">
        <el-option
          v-for="user in changeUsers"
          :key="user.uid"
          :label="user.username"
          :value="user"
          :disabled="user.disabled">
        </el-option>
    </el-select>
        <el-button v-if="!this.displayUsers" type="success" size="small" @click="visibleUsers()">Добавить пользователя</el-button>
        <el-button class="white-space" v-if="this.newUsers" type="success" size="small" @click="addUser()">Добавить пользователя {{this.newUsers.username}}</el-button>
        <!--<el-button class="white-space" v-if="this.newUsers && this.newUsers.b2b_user == true" type="success" size="small" @click="addUser('client')">Добавить пользователя {{this.newUsers.username}} как клиента</el-button>
        <el-button class="white-space" v-if="this.newUsers && this.newUsers.b2b_user == true" type="success" size="small" @click="addUser('competitor')">Добавить пользователя {{this.newUsers.username}} как конкурента</el-button>
 -->
        <el-button class="mobile-btn" v-if="!this.displayKey" size="small"  @click="loadKeywords()"><i class="el-icon-arrow-down"></i></el-button>
        <el-button class="mobile-btn" v-if="this.displayKey" size="small" @click="unloadKeywords()"><i class="el-icon-arrow-up"></i></el-button>

    </div>

    <div class="guides-references-keywords" v-if="keywordList.length > 0">
      <div class="guides-references-keywords-item" v-for="item of keywordList" :key="item.id">
        <span>{{item.keyword}}{{item.approximation !== '-1' ? ' (' + item.approximation + ')' : ''}}</span>
      </div>
    </div>
    <div class="guides-references-keywords stop" v-if="stopWordList.length > 0">
      <div class="guides-references-keywords-item" v-for="item of stopWordList" :key="item.id">
        <span>{{item.keyword}}</span>
      </div>
    </div>
      <div class="guides-references-users-item" v-for="user of usersList" :key="user.id">
        <span>{{user.username}}</span>
        <i class="el-icon-delete" @click="deleteUser(user.uid)" ></i>
      </div>
  </div>
</template>

<script>
  // components

  // api
  import {
    getReferenceGetItemKeywordsApi,
    getReferenceAddItemKeywordApi,
    getReferenceRemoveItemKeywordApi,
    getReferenceUpdateItemApi,
    getReferenceAddItemUsersApi,
    getReferenceRemoveItemUsersApi,
    getReferenceAddItemToClientApi
  } from "../../../../api/references";

  export default {
    name: 'ReferenceItem',
    props: {
      referenceItem: {
        type: Object
      },
      activeEditItemId: {
        type: Number
      }
    },
    data() {
      return {
        keywordList: [],
        newKeyword: '',
        stopWordList: [],
        newStopWord: '',
        approximation: '',
        referenceName: '',
        currentName: '',
        newUsers:'',
        usersList: [],
        isEditMode: false,
        saveKeywordInProgress: false,
        saveReferenceNameInProgress: false,
        displayKey: false,
        displayUsers: false
      };
    },
    computed: {
      changeUsers() {
        console.log('parent', this.$parent)
        let changeUsers = this.$parent.users
        changeUsers[this.$parent.users.length]= {
          "id": 999999999999,
          "username": "Выбрать",
          disabled: true
        }
        return changeUsers
      },
    },
    methods: {
      getRole(role) {
        return this.roles.find(item => item.name === role).title;
      },
      deleteItem() {
        this.$emit("onDeleteItem", this.referenceItem.id);
      },
      editItem() {
        this.$emit("onEditItem", this.referenceItem.id);
      },
      cancelEdit() {
        this.newKeyword = '';
        this.$emit("onCancelEditItem");
      },
      deleteKeyword(id) {
        getReferenceRemoveItemKeywordApi({ reference_item_keyword_id: id }).then(() => {
          this.loadKeywords();
        });
      },
      loadKeywords() {
        getReferenceGetItemKeywordsApi({ reference_item_id: this.referenceItem.id }).then((resp) => {
          this.keywordList = resp.data.filter(item => item.keyword !== '' && item.is_stop === '0');
          this.stopWordList = resp.data.filter(item => item.keyword !== '' && item.is_stop === '1');
          this.displayKey = true
        });
      },
      unloadKeywords() {
        getReferenceGetItemKeywordsApi({ reference_item_id: this.referenceItem.id }).then((resp) => {
          this.keywordList = resp.data.filter(item => item.keyword == '' && item.is_stop === '0');
          this.stopWordList = resp.data.filter(item => item.keyword == '' && item.is_stop === '1');
          this.displayKey = false
        });
      },
      visibleUsers(){
        this.displayUsers = !this.displayUsers;
      },

      saveReferenceName() {
        if (this.referenceName === '' || this.referenceName === this.referenceItem.keyword) {
          return
        }

        this.saveReferenceNameInProgress = false

        const params = {
          reference_id: this.referenceItem.reference_id,
          item_id: this.referenceItem.id,
          keyword: this.referenceName,
          group_id: this.referenceItem.group_id,
        }

        getReferenceUpdateItemApi(params).then(() => {
          this.currentName = this.referenceName
          this.saveReferenceNameInProgress = false
        })
      },
      addKeyword() {
        if (this.newKeyword === '') {
          return
        }

        this.saveKeywordInProgress = true;

        const params = {
          reference_item_id: this.referenceItem.id,
          keyword: this.newKeyword,
          is_stop: false,
          approximation: this.approximation !== '' ? parseInt(this.approximation) : -1
        }

        getReferenceAddItemKeywordApi(params).then(() => {
          this.newKeyword = '';
          this.approximation = '';
          this.saveKeywordInProgress = false;
          this.loadKeywords();
        });
      },
      addUser(type) {
        if (this.newUsers === '') {
          return
        }

        //if (this.newUsers.b2b_user == false) {
          const params = {
            user_id: this.newUsers.uid,
            item_id: this.referenceItem.id
          }
          getReferenceAddItemUsersApi(params).then(() => {
            location.reload();
          });
        //}
        /*if (this.newUsers.b2b_user == true) {
          const params = {
            product_id: +this.newUsers.uid,
            reference_item_id: this.referenceItem.id,
            reference_type: type
          }
          getReferenceAddItemToClientApi(params).then(() => {
            location.reload();
          });
        }*/
      },

      deleteUser(id) {
          const params1 = {
            user_id: id,
            item_id: this.referenceItem.id
          }
          getReferenceRemoveItemUsersApi(params1).then(() => {
            location.reload();
          });
      },
      addStopWord() {
        if (this.newStopWord === '') {
          return
        }

        this.saveKeywordInProgress = true;

        const params = {
          reference_item_id: this.referenceItem.id,
          keyword: this.newStopWord,
          is_stop: true
        }

        getReferenceAddItemKeywordApi(params).then(() => {
          this.newStopWord = '';
          this.saveKeywordInProgress = false;
          this.loadKeywords();
        });
      },
    },
    watch: {
      activeEditItemId() {
        this.isEditMode = this.activeEditItemId === this.referenceItem.id;
      }
    },
    beforeMount() {
      this.currentName = this.referenceItem.keyword
      this.referenceName = this.referenceItem.keyword
      this.usersList = this.referenceItem.users
    }
  };
</script>
<style>
  .el-button {
      margin-left: 10px;
  }
  .guides-references-item {
    padding: 20px;
    border-bottom: 1px solid #eee;
  }
  .guides-references-item:first-child {
    border-top: 1px solid #eee;
  }
  .guides-references-item-head {
    display: flex;
    align-items: center;
  }
  .guides-references-item-head .el-button--small, .el-button--small.is-round {
    padding: 4px;
  }
  .guides-references-item-name {
    margin: 0 20px 0 0;
  }
  .guides-references-item-name.active {
    font-size: 16px;
    font-weight: 500;
  }
  .guides-references-keywords {
    display: flex;
    flex-wrap: wrap;
  }
  .guides-references-keywords-item {
    background-color: #eee;
    border-radius: 3px;
    padding: 3px 10px;
    margin: 10px 10px 0 0;
  }
  .guides-references-users-item {
    border-bottom: 1px solid lightgrey;
    padding: 6px 10px;
    margin: 10px 10px 0 0;
    display: flex;
    justify-content: space-between;
  }
  .guides-references-keywords-item i {
    margin-left: 6px;
    cursor: pointer;
  }
  .guides-references-keywords-edit {
    padding: 15px 0 20px;
  }
  .guides-references-keywords-edit-row {
    display: flex;
    align-items: flex-end;
    margin-top: 10px;
  }
  .guides-references-keywords-edit-row label > span {
    display: block;
    margin-bottom: 4px;
  }
  .guides-references-keywords-edit-row label {
    width: 300px;
    margin-right: 10px;
  }
  .guides-references-keywords-edit-row input[type="number"] {
    padding-right: 0;
  }
  .guides-references-keywords-edit-close {
    margin-top: 10px;
  }
  .guides-references-keywords.stop .guides-references-keywords-item {
    background-color: rgb(248, 185, 185);
  }
  .guides-references-name-edit {
    display: flex;
    align-items: flex-end;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .guides-references-name-edit label > span {
    display: block;
    margin-bottom: 4px;
  }
  .guides-references-name-edit label {
    width: 300px;
    margin-right: 10px;
  }
    @media screen and (max-width: 480px) {
    .guides-references-keywords-edit-row {
      display: block;
    }
    .mobile-btn{
          position: relative;
          top: -20px;
          left: 150px;
    }
  }
</style>